import PubSubWebsocketMetal from "./metal";
import UTIL_SERVER_WS_MESSAGES from "./metal/util.server.messages";

/**
 * PubSubWebsocket
 *
 * A WebSocket wrapper around 'sockette' + 'pubsub-js' for:
 *  - Managing a Sockette WebSocket connection
 *  - Normalizing inbound server payloads
 *  - Sending validated & enriched outbound client messages
 *  - Handling PubSub.js topic-based subscriptions
 *
 * Main usage:
 *   const ws = new PubSubWebsocket({ websocketURL });
 *   ws.subscribe('MY_TOPIC', { receiveMessage: (topic, data) => ... });
 *   ws.sendMessage({ action:'X', topic:'Y', body:{...} });
 * 
 * Note: 
 *   PubSubWebsocketMetal is used internally. Consumers should only use this class PubSubWebsocket.
 */
class PubSubWebsocket {



    /**
     * @param {Object} opts
     * @param {string} opts.websocketURL - Server WebSocket endpoint
     * @param {Function} [opts.funcIsInternalMessage] - Function to identify internal/control messages
     */
    constructor({
        websocketURL, 
        funcIsInternalMessage = UTIL_SERVER_WS_MESSAGES.defaultFuncIsInternalMessage,
        autoPrintState = false,
    } = {}) {
        this.metal = new PubSubWebsocketMetal({ websocketURL, funcIsInternalMessage, autoPrintState });
    };




    /**
     * Validate, build, and send a message via WebSocket.
     * @param {Object} payload - Raw message payload
     */
    sendMessage = (payload) => {
        this.metal.sendMessage(payload);
    };




    /**
     * Subscribe to a PubSub.js topic.
     * @param {string} topic - Topic name
     * @param {Object} opts
     * @param {Function} opts.receiveMessage - Callback(topic, data)
     * @param {any} opts.owner - Owner token/id for subscription tracking
     * @returns {{ unsubscribe: Function, token: string }} 
     */
    subscribe = (topic, { receiveMessage, owner } = {}) => {
        const { unsubscribe, token } = this.metal.subscribe(topic, { receiveMessage, owner });
        return { unsubscribe, token };
    };




    /**
     * Unsubscribe from a PubSub.js topic.
     * Supports lookup by token, handler, or owner.
     */
    unsubscribe = (topic, { token, receiveMessage, owner }) => {
        this.metal.unsubscribe(topic, { token, receiveMessage, owner });
    };




    /** Fully tear down both subscriptions and socket. */
    destroy = () => {
        this.metal.destroy();
    };


    consoleLogState = () => {
        this.metal.consoleLogState();
    }
}

export default PubSubWebsocket;